<template>
  <div class="pagination-fronted">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginationDatas.currentPage"
      :page-sizes="paginationDatas.pageSizes || [10, 20, 30, 50]"
      :page-size="paginationDatas.pageSize"
      layout="total, prev, pager, next,  sizes, jumper"
      :total="paginationDatas.total"
      :pager-count="paginationDatas.pagerCount"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paginaionData: this.paginationDatas,
    };
  },
  watch: {
    paginationDatas: {
      handler(newVal, oldVal) {
        this.paginaionData = newVal;
      },
      deep: true,
    },
  },
  props: {
    paginationDatas: {
      // 分页参数
      default: () => {
        return {
          total: Number, // 总个数
          currentPage: Number, // 当前页
          pageSize: Number,
          pageSizes: Array,
          pagerCount: Number,
        };
      },
      type: Object,
    },
  },
  methods: {
    handleSizeChange(val) {
      this.paginaionData.currentPage = 1;
      this.paginaionData.pageSize = val;
      this.$emit("sizePageChange", this.paginaionData);
    },
    handleCurrentChange(val) {
      this.paginaionData.currentPage = val;
      this.$emit("sizePageChange", this.paginaionData);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-fronted {
  margin: 10px 0;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  color: rgba(118, 133, 151, 1) !important;
}
:deep(.el-pagination) {
  color: rgba(118, 133, 151, 1) !important;
}
:deep(.btn-prev) {
  border: 1px solid rgba(229, 232, 236, 1);
}
:deep(.btn-next) {
  border: 1px solid rgba(229, 232, 236, 1);
}
:deep(.el-pagination__total) {
  color: #768597;
}
:deep(.active) {
  background-color: #266cee !important;
}
:deep(.el-input .el-input--mini .el-input--suffix) {
  & > input {
  }
}
:deep(.el-pagination__jump) {
  color: #768597 !important;
}
</style>
